import { closeRamsRecordModal } from '../State/ramsRecordModal'
import fetch from '../Services/fetch'

export default (shouldReload = false) => async (dispatch) => {

  dispatch(closeRamsRecordModal())

  if (shouldReload) dispatch(fetch())

}